module.exports = __webpack_public_path__ + "static/img/face23.15220c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face23.jpg
// module id = qmmV
// module chunks = 0